/* eslint-disable import/prefer-default-export */
import React, { useRef, useEffect, useMemo } from 'react';
import styled from 'styled-components';

import AntdSelect from 'antd/lib/select';
import tests from '../../../helpers/tests';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 5px;
  @media(max-width: 991px) {
    flex-wrap: wrap;
  }
`;

const VariantWrapper = styled.div`
  width: 100%;
`;
// eslint-disable-next-line max-len
function FieldVariationVariantsItem({ variant, value, valuesRef, onChange, disx }) {
  const currentValue = useMemo(
    () => {
      const choice = variant.choices?.find?.(({ _id }) => _id === value);
      return choice?._id || undefined;
    },
    [variant, value],
  );
  useEffect(
    () => {
      if (currentValue !== value) {
        const newValues = {
          ...valuesRef.current,
        };
        delete newValues[variant._id];
        onChange(newValues);
      }
    },
    [value, currentValue, onChange, valuesRef, variant._id],
  );
  return (
    <VariantWrapper>
      <AntdSelect
        disabled={disx}
        placeholder={variant.label}
        value={currentValue}
        onChange={newValue => onChange({
          ...valuesRef.current,
          [variant._id]: newValue,
        })}
      >
        {(variant.choices || []).map(choice => (
          <AntdSelect.Option
            key={choice._id}
            value={choice._id}
          >
            {choice.label}
          </AntdSelect.Option>
        ))}
      </AntdSelect>
    </VariantWrapper>
  );
}

function FieldVariationVariants(props) {
  const mainForm = props.forms && props.forms.length
  ? props.forms[props.forms.length - 1]
  : props.form;
  const variants = (mainForm?.getFieldValue('variants') || []).filter(
    variant => variant._id && variant.choices?.length
  );
  const value = props.value || {};
  const valuesRef = useRef(value);
  valuesRef.current = value;
  return (
    <Wrapper>
      {variants.map(variant => (
        <FieldVariationVariantsItem
          key={variant._id}
          variant={variant}
          value={value[variant._id]}
          valuesRef={valuesRef}
          onChange={props.onChange}
          // disx={props.disx}
        />
      ))}
    </Wrapper>
  );
}

export const fieldVariationVariants = ['FieldReact', {
  name: 'variants',
  virtual: [],
  // eslint-disable-next-line arrow-body-style, no-unused-vars
  renderContent: (props, field) => {
    // eslint-disable-next-line max-len
    const valid = tests.viewerIsAdminAndDoesNotHavePermissionToEditProductsOtherCases(props);
    return (
      <FieldVariationVariants {...props} disx={valid} />
    );
  },
}];
